module.exports = __webpack_public_path__ + "static/img/ts.6dd35266.png";